import { NewAccountL10n } from './types';

export const l10n: NewAccountL10n = {
  newAccountInstructions: 'new-account.instructions',
  accountProductLabel: 'new-account.account-product.label',
  accountProductPlaceholder: 'new-account.account-product.placeholder',
  firstNameLabel: 'new-account.first-name.label',
  middleNameLabel: 'new-account.middle-name.label',
  lastNameLabel: 'new-account.last-name.label',
  address1Label: 'new-account.address1.label',
  address2Label: 'new-account.address2.label',
  cityLabel: 'new-account.city.label',
  stateLabel: 'new-account.state.label',
  statePlaceholder: 'new-account.state.placeholder',
  zipLabel: 'new-account.zip.label',
  ssnLastFourLabel: 'new-account.ssn-last-four.label',
  dateOfBirthLabel: 'new-account.date-of-birth.label',
  emailLabel: 'new-account.email.label',
  primaryPhoneLabel: 'new-account.phone.label',
  depositSourceLabel: 'new-account.deposit-source.label',
  depositSourcePlaceholder: 'new-account.deposit-source.placeholder',
  amountLabel: 'new-account.amount.label',
  clearModal: {
    title: 'new-account.clear-modal.title',
    text: 'new-account.clear-modal.text',
  },
  cancelBtn: 'new-account.btn.cancel',
  clearBtn: 'new-account.btn.clear',
  confirmBtn: 'new-account.btn.confirm',
  submitBtn: 'new-account.btn.submit',
  depositSource: {
    cash: 'new-account.depositSource.cash',
    check: 'new-account.depositSource.check',
    internalTransfer: 'new-account.depositSource.internal-transfer',
    externalTransfer: 'new-account.depositSource.external-transfer',
  },
  validation: {
    accountProductRequired: 'new-account.validation.account-product.required',
    firstNameRequired: 'new-account.validation.first-name.required',
    lastNameRequired: 'new-account.validation.last-name.required',
    address1Required: 'new-account.validation.address1.required',
    cityRequired: 'new-account.validation.city.required',
    stateRequired: 'new-account.validation.state.required',
    zipRequired: 'new-account.validation.zip.required',
    zipLength: 'new-account.validation.zip.length',
    dateOfBirthOrSsnLastFourRequired: 'new-account.validation.dob-or-ssn.required',
    ssnLastFourLength: 'new-account.validation.ssn.length',
    emailRequired: 'new-account.validation.email.required',
    emailInvalid: 'new-account.validation.email.invalid',
    primaryPhoneRequired: 'new-account.validation.phone.required',
    primaryPhoneLength: 'new-account.validation.phone.length',
    depositSourceRequired: 'new-account.validation.deposit-source.required',
    amountRequired: 'new-account.validation.amount-required',
    amountMin: 'new-account.validation.amount.min',
    amountMax: 'new-account.validation.amount.max',
  },
  confirmation: 'new-account.confirmation',
  textFieldValidation: 'pattern.text-field',
};
